import PropTypes from "prop-types";
import React, { Component } from "react";
import * as AuthActions from "../actions/auth";
import ReportingGroupModal from "../components/account/ReportingGroupModal";
import Alert from "../components/app/Alert";
import ErrorBoundary from "../components/app/ErrorBoundary";
import Footer from "../components/app/Footer";
import Header from "../components/app/Header";
import Modal from "../components/app/modal/Modal";
import ModalProvider from "../components/app/modal/ModalProvider";
import WithRole from "../components/app/WithRole";
import Banners from "../components/banner/Banners";
import ImpersonateAlertModal from "../components/user/ImpersonateAlertModal";
import ImpersonateModal from "../components/user/ImpersonateModal";
import { subscribeToAuthSession } from "../helpers/authSession";
import browserHistory from "../helpers/browserHistory";

export default class App extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    location: PropTypes.object.isRequired,
    onClickCapture: PropTypes.func,
  };

  handleUserUpdate = () => {
    this.forceUpdate();
  };

  handleAuthSessionChange = (change) => {
    this.handleUserUpdate();
    if (change.source === "cross-tab" && change.reason === "cross-tab-session-commit") {
      // A different tab may have changed the effective user (for example,
      // impersonation). Leaving this tab on an admin-only route would make it
      // issue requests for the previous user and surface misleading 403s.
      browserHistory.push("/");
    }
  };

  componentDidMount() {
    if (AuthActions.signedIn()) {
      const user = AuthActions.getUser();
      AuthActions.identifyFS(user);
    }
    document.addEventListener("asset:update-user", this.handleUserUpdate);
    this.unsubscribeAuthSession = subscribeToAuthSession(this.handleAuthSessionChange);
  }

  componentWillUnmount() {
    document.removeEventListener("asset:update-user", this.handleUserUpdate);
    this.unsubscribeAuthSession?.();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    const { children, location, onClickCapture } = this.props;
    const user = AuthActions.getUser();
    const signedIn = AuthActions.signedIn();
    return (
      <div className={signedIn ? "app-shell app-shell--authenticated" : "app-shell"} onClickCapture={onClickCapture}>
        <ModalProvider>
          <Banners />
          <Header show={signedIn} impersonated={AuthActions.isImpersonated()} user={user} location={location} />
          {/* Route elements own pathname-keyed resets. This outer boundary
              protects the routing/session infrastructure without remounting it
              on ordinary navigation. */}
          <ErrorBoundary resetKey={location.pathname}>{children}</ErrorBoundary>
          <Footer show={signedIn} />
          <Alert />
          {/* The user picker inside this modal loads its options eagerly on
              mount, so mounting it for a user without the permission issues a
              rejected impersonation lookup on every page. The Header gates the
              control that opens it on the same permission. */}
          {signedIn && (
            <WithRole authorize="users" action="impersonate">
              <ImpersonateModal location={this.props.location} />
            </WithRole>
          )}
          {signedIn && <ImpersonateAlertModal location={this.props.location} />}
          {signedIn && <ReportingGroupModal />}
          <Modal />
        </ModalProvider>
      </div>
    );
  }
}
